<script lang="ts" setup>
import type { FilterGroupMultiSelect } from "~~/models/filters";

const { filterGroup } = defineProps<{ filterGroup: FilterGroupMultiSelect; size: "sm" | "md" | "lg" }>();

function getSelectedListLabels(filterGroup: FilterGroupMultiSelect): string {
  const labels = filterGroup.selectedList?.map(s => filterGroup.options.find(o => o.value === s)?.label);

  if (!labels?.length) {
    return filterGroup.title;
  }

  return labels.join(", ");
}
</script>

<template>
  <UFormField :class="{ hidden: filterGroup.isHiddenInUI }">
    <USelectMenu
      v-model="(filterGroup as FilterGroupMultiSelect).selectedList!"
      :search-input="false"
      :items="filterGroup.options"
      :size="size"
      label-key="label"
      value-key="value"
      selected-icon="i-ph-check"
      multiple
      data-1p-ignore
    >
      <template #default>
        <span class="truncate">{{ getSelectedListLabels(filterGroup) }}</span>
      </template>
      <template #item-label="{ item }">
        {{ item.label }}
      </template>
    </USelectMenu>
  </UFormField>
</template>

<style scoped>

</style>
